import { ADD_CHILDREN_TO_REQUEST } from "../../../../enums/Request/request.types";

export const addChildrenAction = (data) => {
    return {
        type: ADD_CHILDREN_TO_REQUEST,
        payload: data,
    };
};
